var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuelTypeIcon = function SvgFuelTypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.035.128A.4.4 0 0 0 6.75 0a.38.38 0 0 0-.281.128C6.172.468-.744 8.5.066 12.525a6.818 6.818 0 0 0 13.368 0C14.244 8.501 7.331.469 7.035.128m2.686 9.397-2.625 6a.38.38 0 0 1-.421.217.375.375 0 0 1-.3-.367V11.25h-2.25a.375.375 0 0 1-.345-.518l1.875-4.5A.37.37 0 0 1 6 6h1.875a.37.37 0 0 1 .307.161.38.38 0 0 1 .045.345L7.29 9h2.085a.38.38 0 0 1 .315.169.39.39 0 0 1 .03.356"
  })));
};
export default SvgFuelTypeIcon;